export default "__VITE_ASSET__CgBRJYpS__"